import { createUseStyles } from 'react-jss';

export default createUseStyles(
  {
    root: {
      alignItems: 'center',
      display: 'flex',
      minHeight: 80,
    },

    container: {
      display: 'flex',
      flexGrow: 1,
      gap: 16,
    },

    leftIcon: {
      cursor: 'pointer',
    },

    text: {
      color: '#121212',
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '22px',
    },
  },
  { name: 'NavHeader' },
);
